/* eslint-disable @nx/enforce-module-boundaries */
import { RankingQuestionConfig } from '@hyper-inferno/click-to-rank-core';
import {
  QuestionHandler,
  ITransformationContext,
} from '@hyper-inferno/survey-bot-core';
import { QuestionAnswerObject, SurveyElement } from '@hyper-inferno/survey-elements-core';

export class ClickToRankHandler
  implements QuestionHandler<RankingQuestionConfig> {
  async buildConfig(el: any, ctx: ITransformationContext) {
    const options = await ctx.listBuilding.getOptionsByListId(
      el.config.list_id,
      ctx,
      el.config.randomize_options,
    );

    return {
      ...el.config,
      options,
    };
  }
  getValue(el: SurveyElement, response: QuestionAnswerObject) {
    // Regex: Starts with el.name, followed by _, ends with one or more digits
    const pattern = new RegExp(`^${el.name}_(\\d+)$`);

    return Object.keys(response)
      .filter((key) => pattern.test(key) && typeof response[key] === 'number' && response[key] >= 1) // Check if any number greater than or equal to 0
      .map((key) => {
        const match = key.match(pattern);
        // Now match[1] will contain the digit suffix
        return match ? parseInt(match[1], 10) : null;
      })
      .filter((suffix): suffix is number => suffix !== null);
  }
}
